<template>
        <div id='sqbm'>
              <NavTop title='最美女神/男神蜕变营活动' :islink='true' linkurl='/index'/>
              <div class='content'>
                <img src="http://www.cnihz.cn/static/img/mltb.jpg" class='sqimg'/>
              </div> 
              <div class="title-row-big">最美女神/男神蜕变营</div>
              <div class="normal-row">感谢参加本场活动！</div> 
              <div class="normal-row">您所填写信息已保密；请放心填写。</div> 

              <div class="title-row mt30">姓名</div>
              <div class='halfwidh'>
                  <input placeholder="请输入您的姓名" class='inputclass' v-model='name'/>
               </div>

               <div class="title-row mt30">你的性别</div>
               <div class='halfwidh'>
                  <div class="radiorow"><input type="radio" name='sex' value='1'/><span class="radiolabel">男</span></div>
                  <div class="radiorow"><input type="radio" name='sex' value='2'/><span class="radiolabel">女</span></div>
               </div>


               <div class="title-row mt30">年龄</div>
               <div class='halfwidh'>
                   <input placeholder="请输入您的年龄" class='inputclass' v-model='age'/>
               </div>

               <div class="title-row mt30">想改变什么</div>
               <div class='halfwidh'>
                  <div class="radiorow"><input type="checkbox" name='change' value='1'/><span class="radiolabel">肌肤状态</span></div>
                  <div class="radiorow"><input type="checkbox" name='change' value='2'/><span class="radiolabel">身体状态</span></div>
                  <div class="radiorow"><input type="checkbox" name='change' value='3'/><span class="radiolabel">个人形象</span></div>
               </div>

              <div class="title-row mt30">请上传日常素颜肌肤照片2张</div>
              <div class="imgrow">
                 <div class="imgcol">
                  <van-uploader :after-read="afterRead" :upload-icon="img1==''?undefined:img1" :preview-image='false' image-fit="cover" name='img_1'/>
                  <span>照片1</span>
                 </div>
                 <div class="imgcol">
                  <van-uploader :after-read="afterRead" :upload-icon="img2==''?undefined:img2" :preview-image='false' image-fit="cover" name='img_2'/>
                  <span>照片2</span>
                 </div>
              </div>
              <div class="title-row">请上传日常全身或者半身生活照片2张</div>
              <div class="imgrow">
                 <div class="imgcol">
                  <van-uploader :after-read="afterRead" :upload-icon="img3==''?undefined:img3" :preview-image='false' image-fit="cover" name='img_3'/>
                  <span>照片1</span>
                 </div>
                 <div class="imgcol">
                  <van-uploader :after-read="afterRead" :upload-icon="img4==''?undefined:img4" :preview-image='false' image-fit="cover" name='img_4'/>
                  <span>照片2</span>
                 </div>
              </div>
              <div class="btnrow">
                  <div class="sumitbtn" @click="doBm">
                      确认提交
                  </div>
              </div>
        </div>
</template>
<script>
import NavTop from '@/components/navtop'
import { NoticeBar, Uploader} from 'vant'
//import {put} from '@/api'
export default {
  data(){
      return{
         img1:'',
         img2:'',
         img3:'',
         img4:'',
         bminfo:{},
         sex:'',
         age:'',
         name:'',
         change:[],
         processing:false
      }
  },  
  name: 'sporder2bm',
  methods:{
     doBm(){
        if(this.processing){
           this.$toast("请等待提交完成");return false;
        }

      
        if(this.name==''|| this.name==undefined){
           this.$toast("请先输入你的姓名");return false;
        }


        let sex=this.getSex()
        if(sex==''){
           this.$toast("请选择性别");return false;
        }


        if(this.age==''|| this.age==undefined || isNaN(this.age)){
           this.$toast("请先输入你的年龄");return false;
        }

      
        let change=this.getChange()
        if(change<=0){
           this.$toast("请选择想改变什么");return false;
        }
       
        if(this.img1==''|| this.img1==undefined){
            this.$toast("请上传日常素颜肌肤照片1");return false;
        }
        if(this.img2==''|| this.img2==undefined){
            this.$toast("请上传日常素颜肌肤照片2");return false;
        }
        if(this.img3==''|| this.img3==undefined){
            this.$toast("请上传日常全身或者半身生活照片1");return false;
        }
        if(this.img4==''|| this.img4==undefined){
            this.$toast("请上传日常全身或者半身生活照片2");return false;
        }
        this.bminfo["img1"]=this.img1
        this.bminfo["img2"]=this.img2
        this.bminfo["img3"]=this.img3
        this.bminfo["img4"]=this.img4
        this.bminfo['name']=this.name
        this.bminfo['age']=this.age
        this.bminfo['sex']=sex
        this.bminfo['change']=change

        
        this.processing=true
        this.$post("/mltb/saveMltbBm",{bminfo:this.bminfo}).then((data)=>{
           this.processing=false
           if(data.result.success){
              this.$toast(data.result.info)
              setTimeout(()=>{this.$go("/sporder2")},1000)
           }else{
              this.$toast(data.result.info)
           }
        })
     },

     getSex(){
       let sex=document.getElementsByName('sex')
       let keyvalmap=[1,2]
       let sexval=''
       for(let i=0;i<sex.length;i++){
          if(sex[i].checked==true) sexval=keyvalmap[i]
       }
       return sexval
     },
     getChange(){
       let change=document.getElementsByName('change')
       let changeval=[]
       let nochoosenums=0
       for(let i=0;i<change.length;i++){
         if(change[i].checked==true){
            changeval[i]=1
         }else{
            changeval[i]=0
            nochoosenums++
         }
       }
       if(nochoosenums==3) changeval=-1
       return changeval
     },
     afterRead(file,info) { 
      let name=info.name   
      let tag=name.split("_")
      let index=tag[1]
      const uploadImgFile=file.content
      this.$post("/uploader/headImgBase64",{type:'idcard',image:uploadImgFile}).then((data)=>{
           if(data.result.success){
               this['img'+index]=data.result.info.url 
           }
      })
    }
  },
  components:{
      NavTop,
      [NoticeBar.name]:NoticeBar,
      [Uploader.name]:Uploader
  }
}
</script>
<style scoped>
#sqbm{background-color:#fff;min-height: 100vh;padding-bottom: 0.5rem;}
.content{font-size:0.5rem;overflow-x:hidden;word-break:break-all;text-align: left;width:100%;}
.sqimg{width:100%;display: block;}
::v-deep .fixcon{margin-bottom: 0!important;}
.title-row{font-size:0.35rem;width: 100%;text-align: left;font-weight: 600;padding: 0.3rem 0.3rem 0.1rem 0.3rem;}
.title-row-big{font-size:0.5rem;width: 100%;text-align: left;font-weight: 600;padding: 0 0.3rem;}
.normal-row{font-size:0.35rem;width: 100%;text-align: left;padding:0 0.3rem;}
.mt30{margin-top:0.3rem}
.imgrow{display: flex;flex-flow: row;width: 100%;padding: 0 0.3rem;}
.imgcol{width:25%;display: flex;flex-flow: column nowrap;justify-content: center;font-size:0.25rem;}
.inputclass{border: 1px solid #ccc;padding: 0.2rem;font-size:0.3rem;}
.btnrow{display: flex;flex-flow: row;width: 100%;justify-content: center;align-items: center;padding: 0 0.3rem;margin-top: 0.25rem;}
.sumitbtn{width:100%;border-radius: 0.2rem;background-color: #ee0a24;color:#fff;font-size:0.38rem;height:1rem;display: flex;flex-flow: row nowrap;align-items: center;justify-content: center;}
.halfwidh{width:50%;padding: 0 0.3rem;text-align: left;}
.radiorow{display:flex ;flex-flow: row nowrap;align-items: center;margin-bottom: 0.1rem;}
.radiolabel{margin: 0 0.2rem;font-size:0.35rem}
::v-deep .van-uploader{display:flex ;justify-content: center;}
::v-deep .van-uploader__upload-icon{font-size:80px;}
::v-deep .van-uploader__upload{margin: 0;background-color: #fff;}
</style>


